// Angular
import { Component, OnDestroy, OnInit } from '@angular/core';
// Extern
import { NotifierService } from 'angular-notifier';
import { Subscription } from 'rxjs';
// Models
import { AlertMessage } from 'src/app/models/alert-message.model';
// Services
import { NotificationsService } from 'src/app/services/notifications.service';

@Component({
  selector: 'app-notifier',
  templateUrl: './notifier.component.html',
  styleUrls: ['./notifier.component.scss']
})
export class NotifierComponent implements OnInit, OnDestroy {

  notificationsSubscription: Subscription;
  hideNotificationsSubscription: Subscription;

  constructor(private notifier: NotifierService,
              private motificationsServices: NotificationsService) { }

  ngOnInit(): void {
    this.subscribeToNotifications();
    this.subscribeToHideNotifications();
  }

  ngOnDestroy() {
    if(this.notificationsSubscription!=undefined) { this.notificationsSubscription.unsubscribe(); }
    if(this.hideNotificationsSubscription!=undefined) { this.hideNotificationsSubscription.unsubscribe(); }
  }

  subscribeToNotifications() {
    this.notificationsSubscription = this.motificationsServices.notificationSubject.subscribe(
      (code: string) => {
        this.showNotification(code);
      }
    );
  }

  subscribeToHideNotifications() {
    this.hideNotificationsSubscription = this.motificationsServices.hideNotificationSubject.subscribe(
      (code: string) => {
        this.hideSpecificNotification(code);
      }
    );
  }

	/**
	 * Show a notification
	 *
	 * @param {string} type    Notification type
	 * @param {string} message Notification message
	 */
   public showNotification(code: string): void {
    const alert = new AlertMessage(code);
    this.showSpecificNotification(alert.type, alert.message, code);
	}

	/**
	 * Hide oldest notification
	 */
	public hideOldestNotification(): void {
		this.notifier.hideOldest();
	}

	/**
	 * Hide newest notification
	 */
	public hideNewestNotification(): void {
		this.notifier.hideNewest();
	}

	/**
	 * Hide all notifications at once
	 */
	public hideAllNotifications(): void {
		this.notifier.hideAll();
	}

	/**
	 * Show a specific notification (with a custom notification ID)
	 *
	 * @param {string} type    Notification type
	 * @param {string} message Notification message
	 * @param {string} id      Notification ID
	 */
	public showSpecificNotification( type: string, message: string, id: string ): void {
		this.notifier.show( {
			id,
			message,
			type
		} );
	}

	/**
	 * Hide a specific notification (by a given notification ID)
	 *
	 * @param {string} id Notification ID
	 */
	public hideSpecificNotification( id: string ): void {
		this.notifier.hide( id );
	}

}
